import _ from 'lodash';
import { Icon, Label } from 'semantic-ui-react';
import { createInitials } from '../../../../global/common/dataAdjust';
import { formatItem, formatTypes } from '../../../../global/common/dateFormatting';
import { matchCalcs } from '../../helpers/match';
import { _matchLsTypes } from '../../cnr/reducers/SportsDataReducer';
import { gEnums } from '../../../../global/enums/globalEnums';
import { getSectionColor } from '../../create/sectionColors';
import { _matchDisplayTypes } from './MatchContent';
import { useMatchResults } from 'projectSpecific/sports/useHelpers/useMatchResults';

const MatchDivs = ({
  _teamKey,
  allowEdits,
  handleShow_matchOptions,
  match: match_current,
  matchDisplayType,
  matchScheduleDisplayType,
  mdps,
  results_matchDay,
}) => {

  const { home, away, pending, _status, ls, poolKey, poolName, isConsolation, matchNumber, isPlayoff, _itemKey } = match_current ?? {}
  const { home: home_pending, away: away_pending } = pending ?? {}
  const { isBye, isPendingish } = _status ?? {}

  const { resolvedResult, sourceUsed } = useMatchResults({ match_true: match_current })

  const trimText = (text, maxLength) => {
    if (!_.isString(text)) return text;
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };

  const homeIcon = (value) => <Icon color={value !== 'TBD' ? 'green' : 'grey'} name={'map marker alternate'} />
  const locationIcon = (home) => <Icon color={home?.id === _teamKey ? 'teal' : 'orange'} name={home?.id === _teamKey ? 'home' : 'bus'} />
  const trophyIcon = (isPlayoff) => isPlayoff && <Icon color={'blue'} name={'trophy'} />
  const dotIcon = (lsProps) => <Icon color={lsProps.lsColor} name={lsProps.lsIcon} />
  const slIcon = (lsProps, isPlayoff) => {
    if (isPlayoff) {
      return trophyIcon(isPlayoff)
    } else {
      return dotIcon(lsProps)
    }
  }

  const getLsProps = () => {

    let _ls = ls

    if (isPlayoff) {
      _ls = poolKey ? _.startCase(poolKey) : 'Playoffs'
      if (isConsolation) {
        _ls = _ls.replace('Finals', 'Consolation')
      } else if (isPlayoff) {
        if (poolKey !== 'finals' && matchNumber) {
          _ls += ' - #' + matchNumber
        }
      }
    }

    let _lsColor = 'black';
    let _lsIcon = 'circle thin'

    switch (match_current._matchCollectionKey) {
      case _matchLsTypes.exhibition:
        _lsColor = 'orange'
        break;
      case _matchLsTypes.tournament:
        _lsColor = 'purple'
        _ls = 'Tournament'
        break;
      case _matchLsTypes.nonDistrict:
        _lsColor = 'grey'
        _lsIcon = 'circle outline'
        break;
      default:
        if (matchCalcs.isNon(match_current._matchCollectionKey) || matchCalcs.isNon(match_current.sections)) {
          _lsColor = 'green'
          _lsIcon = 'circle outline'
        } else {
          _lsColor = isPlayoff ? 'blue' : 'green'
        }
    }

    if (isPlayoff) {
      _lsIcon = 'trophy'
      _lsColor = 'grey'
    }

    return { _ls, lsColor: _lsColor, lsIcon: _lsIcon }

  }

  const locationPlayoffText = (isBye, locationName, homeName) => {
    let locationText = ''
    let locationNotConfirmed = false
    if (isBye) {
      locationText = ' '
    } else {
      if (!locationName) {
        locationText = homeName ? homeName : 'TBD'
        locationNotConfirmed = true
      } else {
        locationText = locationName
      }
    }
    return { locationText, locationNotConfirmed }
  }

  return mdps && mdps.map((propKey, index) => {

    if (Array.isArray(propKey)) {
      // Combine the values with a hyphen between them and wrap in a div with class from the first part of the array

      let combinedValues = propKey.map((key) => _.get(match_current, key, '')).join(' - ');

      if (resolvedResult) {
        let combinedValuez = propKey.map((key) => _.get(match_current, key, '')).join(' - ');
      }

      if (results_matchDay) {
        const mdm = { _results: results_matchDay }
        combinedValues = propKey.map((key) => _.get(mdm, key, '')).join(' - ');
      }

      const className = propKey[0].split('.')[0]; // Get the first part of the property (before the dot)
      let oc = null;

      return (
        <div key={index} className={className} onClick={(e) => { oc && oc(e, match_current) }}>
          {combinedValues}
        </div>
      );
    } else {

      // Handle single property
      let className = `match-${propKey.replace(/\./g, '-')}`;
      let value = _.get(match_current, propKey, '');
      let title = value;
      let icon;
      let oc = null;

      className = className.replace('_', '')

      switch (propKey) {
        case 'pending.away.originalSeed':
        case 'pending.home.originalSeed':
          value = <Label circular size='mini' color={'grey'}>{value ? value : '-'}</Label>
          break;
        case 'pending.away.matchNumber':
          const _poolNameA = _.get(match_current, 'pending.away.poolName', '');
          value = `Winner ${_poolNameA}/#${value}`
          break;
        case 'pending.home.matchNumber':
          const _poolNameH = _.get(match_current, 'pending.home.poolName', '');
          value = `Winner ${_poolNameH}/#${value}`
          break;
        case 'away.seed':
          value = <Label color={getSectionColor(away?.sections)} circular size='mini'>{value ? value : '-'}</Label>
          break;
        case 'home.seed':
          value = <Label color={getSectionColor(home?.sections)} circular size='mini'>{value ? value : '-'}</Label>
          break;
        case 'matchNumber':
          if (isPendingish) {
            value = 'pending'
          } else {
            value = '# ' + value
          }
          break;
        case 'startDate':
          switch (matchScheduleDisplayType) {
            case gEnums.matchScheduleDisplayTypes.teamSchedule:
              icon = locationIcon(home)
              break;
            default:
          }
          switch (matchScheduleDisplayType) {
            case gEnums.matchScheduleDisplayTypes.levelOverviewMatches:
              value = formatItem(formatTypes.dateDayMonth, value)
              break;
            default:
              // value = formatItem(formatTypes.shortDate, value)
              value = value ? formatItem(formatTypes.dateDayMonth, value) : 'TBD'
          }
          break;
        case 'ls':
          icon = slIcon(getLsProps())
          if (isConsolation) {
            value = value.replace('Finals', 'Consolation')
          }
          break;
        case 'location.name':
          const { locationText } = locationPlayoffText(isBye, value, home?.name)
          value = locationText ? locationText : 'TBD'
          icon = homeIcon(locationText)
          oc = allowEdits ? handleShow_matchOptions : null
          break;
        case 'home.name':
        case 'away.name':
        case 'opponent.name':
          switch (propKey) {
            case 'home.name':
              if (home?.levels === _matchLsTypes.Non) {
                className += ' nd'
              }
              break;
            case 'away.name':
              if (away?.levels === _matchLsTypes.Non) {
                className += ' nd'
              }
              break;
            default:
            // nothing
          }

          switch (matchDisplayType) {
            case _matchDisplayTypes.levelOverviewMatches:
              value = createInitials(value)
              break;
            default:
              value = trimText(value, '20')
            // nothing
          }
          break;
        case 'startTime':
          if (isBye) {
            value = '---'
          }
          oc = allowEdits ? handleShow_matchOptions : null
          value = value ? value : 'TBD'
          break;
        default:
        // noting
      }

      return (
        <div key={index} className={className} title={title} onClick={(e) => { oc && oc(e, match_current, propKey) }}>
          {icon}
          {value}
        </div>
      );
    }
  });
};

export default MatchDivs